import React from "react";
import type { EdgeData, NodePosition } from "./types";

interface MindMapEdgesProps {
  edges: EdgeData[];
  positions: Record<string, NodePosition>;
}

export const MindMapEdges: React.FC<MindMapEdgesProps> = ({ edges, positions }) => {
  return (
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      style={{ overflow: "visible" }}
    >
      <defs>
        <linearGradient id="mind-map-edge-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
      {edges.map((edge) => {
        const fromPos = positions[edge.from];
        const toPos = positions[edge.to];
        if (!fromPos || !toPos) return null;

        const x1 = fromPos.right.x;
        const y1 = fromPos.right.y;
        const x2 = toPos.left.x;
        const y2 = toPos.left.y;

        const dx = Math.abs(x2 - x1) * 0.5;
        const path = `M ${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`;

        return (
          <path
            key={edge.id}
            d={path}
            fill="none"
            stroke="url(#mind-map-edge-gradient)"
            strokeWidth={2}
            strokeLinecap="round"
            opacity={0.6}
          />
        );
      })}
    </svg>
  );
};
